export enum ELocale {
  ch = 'ch',
  de = 'de',
  en = 'en'
}
